(function () {
  document.documentElement.classList.remove('no-js');

  function escapeHtml(value) {
    return String(value || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }

  function formatMoney(cents, format) {
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      return window.Shopify.formatMoney(cents, format);
    }
    return '$' + (Number(cents || 0) / 100).toFixed(2);
  }

  var heroSlider = document.querySelector('[data-hero-slider]');
  var heroSlides = document.querySelectorAll('[data-hero-slide]');
  if (heroSlides.length > 1) {
    var currentHeroSlide = 0;
    var heroPaused = false;
    var heroTimer = null;

    /* Slides can carry their own dwell time via data-hero-duration. The Suppli
       Ads slide asks for longer because it has copy to read; every other slide
       keeps the original 2s. */
    var heroDuration = function (index) {
      var value = parseInt(heroSlides[index].getAttribute('data-hero-duration'), 10);
      return isNaN(value) ? 2000 : value;
    };

    /* This used to be a fixed setInterval that simply skipped ticks while
       paused, so resuming could flip the slide almost immediately and every
       slide had to share one duration. A self-scheduling timeout gives each
       slide its own dwell and makes pause/resume exact. */
    var heroSchedule = function () {
      window.clearTimeout(heroTimer);
      if (heroPaused) return;
      heroTimer = window.setTimeout(advanceHero, heroDuration(currentHeroSlide));
    };

    /* The Suppli slide swaps the hero copy for its own. */
    var syncHeroCopy = function () {
      if (!heroSlider) return;
      heroSlider.classList.toggle('is-suppli', heroSlides[currentHeroSlide].hasAttribute('data-hero-suppli'));
    };

    var advanceHero = function () {
      heroSlides[currentHeroSlide].classList.remove('is-active');
      currentHeroSlide = (currentHeroSlide + 1) % heroSlides.length;
      heroSlides[currentHeroSlide].classList.add('is-active');
      syncHeroCopy();
      heroSchedule();
    };

    var heroPause = function () {
      heroPaused = true;
      window.clearTimeout(heroTimer);
      if (heroSlider) heroSlider.classList.add('is-paused');
    };
    var heroResume = function () {
      heroPaused = false;
      if (heroSlider) heroSlider.classList.remove('is-paused');
      heroSchedule();
    };

    syncHeroCopy();
    heroSchedule();

    if (heroSlider) {
      heroSlider.addEventListener('mouseenter', heroPause);
      heroSlider.addEventListener('mouseleave', heroResume);
      heroSlider.addEventListener('touchstart', heroPause, { passive: true });
      heroSlider.addEventListener('touchend', function () {
        window.setTimeout(heroResume, 2000);
      }, { passive: true });
    }
  }

  var revealNodes = document.querySelectorAll('.reveal-section, .reveal-item, .collection-description');
  if ('IntersectionObserver' in window) {
    var revealObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          revealObserver.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });

    revealNodes.forEach(function (node, index) {
      if (node.classList.contains('reveal-item')) {
        node.style.transitionDelay = Math.min(index % 8, 7) * 55 + 'ms';
      }
      revealObserver.observe(node);
    });
  } else {
    revealNodes.forEach(function (node) { node.classList.add('is-visible'); });
  }

  var openers = document.querySelectorAll('[data-menu-open]');
  var closers = document.querySelectorAll('[data-menu-close]');
  var drawer = document.querySelector('[data-menu-drawer]');
  var backdrop = document.querySelector('.drawer-backdrop');

  function setMenu(open) {
    if (!drawer || !backdrop) return;
    drawer.classList.toggle('is-open', open);
    backdrop.classList.toggle('is-open', open);
    document.documentElement.classList.toggle('menu-open', open);
  }

  openers.forEach(function (button) {
    button.addEventListener('click', function () { setMenu(true); });
  });
  closers.forEach(function (button) {
    button.addEventListener('click', function () { setMenu(false); });
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') {
      setMenu(false);
      setCart(false);
    }
  });

  var searchForms = document.querySelectorAll('[data-live-search]');
  searchForms.forEach(function (form) {
    var input = form.querySelector('[data-live-search-input]');
    var results = form.querySelector('[data-live-search-results]');
    var timer;

    if (!input || !results || !window.fetch) return;

    function closeResults() {
      results.classList.remove('is-open');
    }

    function renderResults(products) {
      if (!products.length) {
        results.innerHTML = '<p class="live-search-empty">No products found.</p>';
        results.classList.add('is-open');
        return;
      }

      results.innerHTML = products.slice(0, 8).map(function (product) {
        var imageSrc = product.image;
        if (imageSrc && typeof imageSrc === 'object') imageSrc = imageSrc.url || imageSrc.src;
        var image = imageSrc ? '<img src="' + escapeHtml(imageSrc) + '" alt="' + escapeHtml(product.title) + '">' : '';
        var price = product.price ? '<small>' + escapeHtml(product.price) + '</small>' : '';
        return '<a class="live-search-item" href="' + escapeHtml(product.url) + '">' + image + '<span><strong>' + escapeHtml(product.title) + '</strong>' + price + '</span></a>';
      }).join('');
      results.classList.add('is-open');
    }

    input.addEventListener('input', function () {
      var query = input.value.trim();
      window.clearTimeout(timer);
      if (query.length < 2) {
        closeResults();
        results.innerHTML = '';
        return;
      }

      timer = window.setTimeout(function () {
        fetch('/search/suggest.json?q=' + encodeURIComponent(query) + '&resources[type]=product&resources[limit]=8&resources[options][fields]=title')
          .then(function (response) { return response.json(); })
          .then(function (data) {
            renderResults((data.resources && data.resources.results && data.resources.results.products) || []);
          })
          .catch(closeResults);
      }, 180);
    });

    document.addEventListener('click', function (event) {
      if (!form.contains(event.target)) closeResults();
    });
  });

  var cartDrawer = document.querySelector('[data-cart-drawer]');
  var cartBackdrop = document.querySelector('.cart-drawer-backdrop');
  var cartOpeners = document.querySelectorAll('[data-cart-open]');
  var cartClosers = document.querySelectorAll('[data-cart-close]');
  function setCart(open) {
    if (!cartDrawer || !cartBackdrop) return;
    cartDrawer.classList.toggle('is-open', open);
    cartBackdrop.classList.toggle('is-open', open);
    document.documentElement.classList.toggle('cart-open', open);
  }

  cartOpeners.forEach(function (opener) {
    opener.addEventListener('click', function (event) {
      event.preventDefault();
      setCart(true);
    });
  });
  cartClosers.forEach(function (closer) {
    closer.addEventListener('click', function () { setCart(false); });
  });

  /* Cart changes (drawer, cart page, add to cart) are handled by the
     queued cart module in assets/auksales-redesign.js, which uses this to
     open the drawer. */
  window.AUKTheme = window.AUKTheme || {};
  window.AUKTheme.openCart = function () { setCart(true); };
  window.AUKTheme.closeCart = function () { setCart(false); };

  document.querySelectorAll('[data-support-widget]').forEach(function (widget) {
    var panel = widget.querySelector('[data-support-panel]');
    var toggles = widget.querySelectorAll('[data-support-toggle]');
    var menu = widget.querySelector('[data-support-menu]');
    var back = widget.querySelector('[data-support-back]');
    var answers = widget.querySelectorAll('[data-support-answer]');

    function openPanel(open) {
      if (!panel) return;
      panel.classList.toggle('is-open', open);
      panel.setAttribute('aria-hidden', open ? 'false' : 'true');
      toggles.forEach(function (toggle) { toggle.setAttribute('aria-expanded', open ? 'true' : 'false'); });
      if (!open) showMenu();
    }

    function showMenu() {
      if (menu) menu.classList.remove('is-hidden');
      if (back) back.classList.remove('is-visible');
      answers.forEach(function (answer) { answer.classList.remove('is-active'); });
    }

    toggles.forEach(function (toggle) {
      toggle.addEventListener('click', function () {
        openPanel(!panel.classList.contains('is-open'));
      });
    });

    widget.querySelectorAll('[data-support-question]').forEach(function (button) {
      button.addEventListener('click', function () {
        var key = button.getAttribute('data-support-question');
        if (menu) menu.classList.add('is-hidden');
        if (back) back.classList.add('is-visible');
        answers.forEach(function (answer) {
          answer.classList.toggle('is-active', answer.getAttribute('data-support-answer') === key);
        });
      });
    });

    if (back) back.addEventListener('click', showMenu);
  });

  document.querySelectorAll('[data-product-tabs]').forEach(function (shell) {
    var source = shell.querySelector('[data-product-description-source]');
    var nav = shell.querySelector('[data-product-tabs-nav]');
    var content = shell.querySelector('[data-product-tabs-content]');
    if (!source || !nav || !content) return;

    var raw = source.innerHTML.trim();
    var labels = {
      highlights: 'Highlights',
      description: 'Description',
      features: 'Features',
      specs: 'Specs',
      faq: 'FAQ',
      shipping: 'Shipping'
    };
    var aliases = {
      'HIGHLIGHTS': 'highlights',
      'DESCRIPTION': 'description',
      'SPECS': 'specs',
      'SPECIFICATIONS': 'specs',
      'FEATURES': 'features',
      'FREQUENTLY ASKED QUESTIONS': 'faq',
      'FAQ': 'faq',
      'SHIPPING & RETURNS': 'shipping',
      'SHIPPING AND RETURNS': 'shipping',
      'SHIPPING': 'shipping'
    };
    var order = ['highlights', 'description', 'features', 'specs', 'faq', 'shipping'];
    var sections = {};
    var text = raw.replace(/<(h[1-6]|p|div|strong|b)[^>]*>/gi, '\n').replace(/<\/(h[1-6]|p|div|strong|b)>/gi, '\n');
    /* "Features" only counts when it is a heading on its own line (with or
       without a colon). 45 older products use the word "features" in
       ordinary sentences, which must not be split. */
    text = text.replace(/\n[ \t]*(?:<[^>\n]*>[ \t]*)*(?:KEY )?FEATURES:?[ \t]*(?:<\/[^>\n]*>[ \t]*)*(?=\n)/gi, '\n@@FEATURES@@');
    /* Headings only count on a line of their own (optionally ending in a
       colon, optionally wrapped in inline tags such as <span>). Matching them anywhere used to cut descriptions at ordinary
       words - "storage and shipping lightweight boxes" lost everything after
       "shipping" to the fixed Shipping tab. */
    var markerRegex = /\n[ \t]*(?:<[^>\n]*>[ \t]*)*(HIGHLIGHTS|DESCRIPTION|SPECS|SPECIFICATIONS|FREQUENTLY ASKED QUESTIONS|FAQ|SHIPPING &amp; RETURNS|SHIPPING & RETURNS|SHIPPING AND RETURNS|SHIPPING)[ \t]*:?[ \t]*(?:<\/[^>\n]*>[ \t]*)*(?=\n)/gi;
    var normalized = text.replace(markerRegex, function (match, name) {
      return '\n@@' + name.replace('&amp;', '&').toUpperCase() + '@@';
    });
    var parts = normalized.split(/\n@@(.+?)@@\n/);
    if (parts.length > 1) {
      /* Text before the first heading is the sales pitch. It used to be
         discarded, which hid the opening paragraph (and, before "Features"
         was a marker, the whole features list) on Cotton Valley products. */
      var lead = String(parts[0] || '').trim();
      if (lead && lead.replace(/<[^>]*>/g, '').trim()) sections.description = lead;
      for (var i = 1; i < parts.length; i += 2) {
        var key = aliases[String(parts[i]).trim()];
        var body = String(parts[i + 1] || '').trim();
        if (key && body) sections[key] = body;
      }
    }
    if (!Object.keys(sections).length && raw) sections.description = raw;
    sections.shipping = [
      '<p><strong>Free shipping for all products.</strong></p>',
      '<p>Easy 30-day returns are available on eligible items.</p>',
      '<p>Learn more in our <a href="/policies/shipping-policy">Shipping Policy</a> and <a href="/policies/refund-policy">Refund Policy</a>.</p>'
    ].join('');

    source.remove();
    order.forEach(function (key) {
      if (!sections[key]) return;
      var button = document.createElement('button');
      button.type = 'button';
      button.textContent = labels[key];
      button.setAttribute('role', 'tab');
      button.setAttribute('data-tab-key', key);
      var panel = document.createElement('div');
      panel.className = 'product-tab-panel rte';
      panel.setAttribute('role', 'tabpanel');
      panel.setAttribute('data-tab-panel', key);
      panel.innerHTML = /</.test(sections[key]) ? sections[key] : sections[key].split(/\n+/).filter(Boolean).map(function (line) { return '<p>' + escapeHtml(line.trim()) + '</p>'; }).join('');
      nav.appendChild(button);
      content.appendChild(panel);
    });
    var reviewsRoot = document.querySelector('[data-reviews]');
    if (reviewsRoot) {
      var reviewsButton = document.createElement('button');
      reviewsButton.type = 'button';
      reviewsButton.textContent = 'Reviews';
      reviewsButton.setAttribute('role', 'tab');
      reviewsButton.setAttribute('data-tab-key', 'reviews');
      reviewsButton.addEventListener('click', function () {
        reviewsRoot.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
      nav.appendChild(reviewsButton);
    }

    var buttons = nav.querySelectorAll('button');
    var panels = content.querySelectorAll('[data-tab-panel]');
    function activate(key) {
      buttons.forEach(function (button) { button.classList.toggle('is-active', button.getAttribute('data-tab-key') === key); });
      panels.forEach(function (panel) { panel.classList.toggle('is-active', panel.getAttribute('data-tab-panel') === key); });
    }
    buttons.forEach(function (button) {
      button.addEventListener('click', function () {
        if (button.getAttribute('data-tab-key') !== 'reviews') activate(button.getAttribute('data-tab-key'));
      });
    });
    if (buttons[0]) activate(buttons[0].getAttribute('data-tab-key'));
  });

  document.querySelectorAll('[data-reviews]').forEach(function (root) {
    if (!window.fetch) return;
    var supabaseUrl = 'https://mkvvuxggoonyhshvhmpm.supabase.co';
    var supabaseKey = 'sb_publishable_5Zi9_TifR_wMuscg62r6xw_yY82oeIQ';
    var handle = root.getAttribute('data-product-handle');
    var summary = root.querySelector('[data-review-summary]');
    var list = root.querySelector('[data-review-list]');
    var form = root.querySelector('[data-review-form]');
    var currentReviews = [];

    function stars(value) {
      var rating = Math.round(Number(value) || 0);
      return '★★★★★'.split('').map(function (star, index) {
        return '<span class="' + (index < rating ? 'is-filled' : '') + '">' + star + '</span>';
      }).join('');
    }

    function renderReviews(rows) {
      var count = rows.length;
      var avg = count ? rows.reduce(function (sum, row) { return sum + Number(row.rating || 0); }, 0) / count : 0;
      if (summary) summary.innerHTML = count ? '<span class="review-stars">' + stars(avg) + '</span><strong>' + avg.toFixed(1) + '</strong><span>(' + count + ' reviews)</span>' : 'No reviews yet';
      if (!list) return;
      list.innerHTML = count ? rows.map(function (row) {
        var date = row.created_at ? new Date(row.created_at).toLocaleDateString() : '';
        return '<article class="review-item"><div class="review-stars">' + stars(row.rating) + '</div><div class="review-item__meta"><strong>' + escapeHtml(row.customer_name || 'Verified customer') + '</strong><span>' + escapeHtml(date) + '</span></div><h3>' + escapeHtml(row.title) + '</h3><p>' + escapeHtml(row.body) + '</p></article>';
      }).join('') : '<p class="review-empty">Be the first to review this product.</p>';
    }

    fetch(supabaseUrl + '/rest/v1/reviews?select=id,customer_name,rating,title,body,created_at&published=eq.true&product_handle=eq.' + encodeURIComponent(handle) + '&order=created_at.desc', {
      headers: { apikey: supabaseKey, Authorization: 'Bearer ' + supabaseKey }
    }).then(function (response) { return response.json(); }).then(function (rows) {
      currentReviews = Array.isArray(rows) ? rows : [];
      renderReviews(currentReviews);
    }).catch(function () {
      if (summary) summary.textContent = 'Reviews unavailable';
    });

    if (!form) return;
    var ratingInput = form.querySelector('input[name="rating"]');
    var ratingButtons = form.querySelectorAll('[data-rating]');
    function setRating(value) {
      ratingInput.value = value;
      ratingButtons.forEach(function (button) {
        button.classList.toggle('is-active', Number(button.getAttribute('data-rating')) <= value);
      });
    }
    ratingButtons.forEach(function (button) {
      button.addEventListener('click', function () { setRating(Number(button.getAttribute('data-rating'))); });
    });
    setRating(5);

    form.addEventListener('submit', function (event) {
      event.preventDefault();
      var message = form.querySelector('[data-review-message]');
      var elements = form.elements;
      var payload = {
        product_handle: handle,
        customer_email: root.getAttribute('data-customer-email'),
        customer_name: elements.customer_name.value,
        rating: Number(ratingInput.value),
        title: elements.title.value,
        body: elements.body.value,
        published: true
      };
      if (message) message.textContent = 'Submitting...';
      fetch(supabaseUrl + '/rest/v1/reviews', {
        method: 'POST',
        headers: { apikey: supabaseKey, Authorization: 'Bearer ' + supabaseKey, 'Content-Type': 'application/json', Prefer: 'return=representation' },
        body: JSON.stringify(payload)
      }).then(function (response) {
        if (!response.ok) throw new Error('Review submission failed');
        return response.json();
      }).then(function (rows) {
        var posted = rows && rows[0] ? rows[0] : {
          customer_name: payload.customer_name,
          rating: payload.rating,
          title: payload.title,
          body: payload.body,
          created_at: new Date().toISOString()
        };
        currentReviews = [posted].concat(currentReviews);
        renderReviews(currentReviews);
        form.reset();
        setRating(5);
        if (message) message.textContent = 'Thanks. Your review is now live.';
      }).catch(function () {
        if (message) message.textContent = 'We could not submit the review. Please try again.';
      });
    });
  });
})();
